import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {

  public loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  hideScroll(): void {
    this.renderer.addClass(this.document.body, 'overflow-hidden');
  }

  showScroll(): void {
    this.renderer.removeClass(this.document.body, 'overflow-hidden');
  }

  get loadingObservable(): Observable<boolean> {
    return this.loading.asObservable();
  }

  setLoader(value: boolean) {
    this.loading.next(value);
  }

  showLoader() {
    this.hideScroll();
    this.setLoader(true);
  }

  hideLoader() {
    this.showScroll();
    this.setLoader(false);
  }
}
